import React, { useState } from "react";
import styles from "./styles.module.css";
import { Cancel, IgniteInfoIcon, igniteLogo, IgniteVector1, IgniteVector2 } from "../../../../assets";

export default function StartupIgnite() {
  const [openPage, setOpenPage] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      {openPage ? (
        <section className={styles["ignite"]}>
          <span className={styles["vector-1"]}>
            <IgniteVector1 />
          </span>
          <span className={styles["vector-2"]}>
            <IgniteVector2 />
          </span>
          <div className={styles["ignite-container"]}>
            <div className={styles["ignite-header"]}>
              <img src={igniteLogo} />
              <span onClick={() => setOpenPage(false)}>
                <Cancel />
              </span>
            </div>
            <div className={styles["ignite-body"]}>
              <h1>Call for Application</h1>
              <div className={styles["ignite-content"]}>
                <div className={styles["ignite-content_header"]}>
                  <h2>Genesys Startup Boost</h2>
                  <h2>2024 Edition</h2>
                </div>
                <div className={styles["ignite-content_content"]}>
                  <p>
                    In this year&apos;s edition, we are seeking to identify, support, and accelerate startups that
                    harness technology and innovation to create impactful solutions for some of the nation&apos;s most
                    pressing economic issues.
                  </p>
                  <p>
                    At the heart of this initiative lies a commitment to fostering a vibrant ecosystem where ideas can
                    flourish, networks can expand, and groundbreaking solutions can be brought to life.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles["ignite-footer"]}>
            <h2>Application Is Open</h2>
            <div className={styles["ignite-footer_content"]}>
              <button className={styles["apply-btn"]}>Apply Now</button>
              <button className={styles["learn-btn"]} onClick={()=>setModalOpen(true)}>Learn more</button>
            </div>
          </div>
        </section>
      ) : (
        <section className={styles["ignite"]}>
          <span className={styles["vector-1"]}>
            <IgniteVector1 />
          </span>
          <span className={styles["vector-2"]}>
            <IgniteVector2 />
          </span>
          <div className={styles["closed-container"]}>
            <div className={styles["closed-image"]}>
              <img src={igniteLogo} />
            </div>
            <div className={styles["closed-body"]}>
              <h1>Application is open</h1>
              <div className={styles["closed-content"]}>
                <button className={styles["apply-btn"]}>Apply Now</button>
                <button className={styles["learn-icon"]} onClick={()=>setModalOpen(true)}>
                  <IgniteInfoIcon />
                </button>
              </div>
            </div>
          </div>
        </section>
      )}
      {modalOpen && <IgniteModal closeModal={()=>setModalOpen(false)} />}
    </>
  );
}

function IgniteModal({closeModal}) {
  return (
    <div className={styles["ignite-modal"]}>
      <div className={styles["modal-container"]}>
        <div className={styles["modal-header"]}>
          <div className={styles["modal-header_container"]}>
            <h1>Empowering Startups for Nigeria&apos;s Economic Growth</h1>
            <span className={styles["modal-close"]} onClick={closeModal}>
              <Cancel />
            </span>
          </div>
        </div>
        <div className={styles["modal-body"]}>
          <p>
            As Nigeria continues to navigate economic challenges, the role of startups in driving sustainable growth and
            fostering economic resilience cannot be overstated. It is within this dynamic context that our plan for
            startup engagement for the upcoming Genesys Ignite 2024 is built.
          </p>
          <p>
            Participating startups will have the unique opportunity to engage with industry leaders, gain insights from
            seasoned entrepreneurs, and showcase their innovations to a wide audience of investors, partners, and
            stakeholders. From pre-event bootcamps and workshops to dynamic pitch sessions and post-event mentorship,
            our comprehensive program is designed to equip startups with the tools they need to succeed and scale their
            ventures.
          </p>
        </div>
      </div>
    </div>
  );
}
